<template>
  <VDialog persistent v-model="dialog" width="700">
    <VCard>
      <VCardTitle
        class="d-flex justify-sm-space-between"
        style="border-bottom: 1px solid #dfe2e9"
      >
        <span style="font-weight: 600">
          {{ $t("basicToolReports") }}
        </span>
        <span @click="close" style="cursor: pointer">
          <vue-icon icon="newBoldCloseIcon" />
        </span>
      </VCardTitle>
      <VCardText>
        <ValidationObserver ref="formObs" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(materialReport)">
            <div style="display: flex; gap: 10px; margin: 20px 0px">
              <CustomDatePicker
                style="width: 50%"
                type="date"
                rules="required"
                :label="$t('from')"
                :max="new Date()"
                class="user_input no-margin"
                v-model="reportFilter.fromDate"
              ></CustomDatePicker>
              <CustomDatePicker
                style="width: 50%"
                type="date"
                rules="required"
                :label="$t('to')"
                :max="new Date()"
                class="user_input no-margin"
                v-model="reportFilter.toDate"
              ></CustomDatePicker>
            </div>

            <VueSelect
              ref="warehouseSelectRef"
              infinite
              item-value="id"
              rules="required"
              @item-resolved="setWarehouse"
              @next-page-resolved="
                (data) => setWarehouse([...warehouseList, ...data])
              "
              :get-item-promise="getWarehouses"
              v-model="reportFilter.warehouseId"
              :items="warehouseList"
              :label="$t('selectWarehouse')"
              class="product-select-in-modal"
            ></VueSelect>
            <!--            <VRadioGroup row v-model="reportFilter.downloadFileType">-->
            <!--              <VRadio label="Excel" value="excel"></VRadio>-->
            <!--              <VRadio label="Word" value="word"></VRadio>-->
            <!--            </VRadioGroup>-->
            <div
              class="text-right mt-5"
              style="display: flex; justify-content: space-between"
            >
              <v-btn @click="close" color="lightGrey" dark style="width: 45%">
                {{ $t("toCancel") }}
              </v-btn>
              <VBtn
                :loading="loading"
                color="primary"
                type="submit"
                style="width: 45%"
                >{{ $t("downloadFile") }}</VBtn
              >
            </div>
          </form>
        </ValidationObserver>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import { downloadBlobFile, makerPagination } from "@/utils/pureFunctions.js";
import VueSelect from "@/components/ui/vue-select/VueSelect.vue";
import { USER_ROLES } from "@/utils/constants.js";

// const FILE_TYPE = {
//   excel: {
//     ext: "xls",
//     url: "reports/report-excel",
//     type: "excel",
//   },
//   word: {
//     ext: "doc",
//     url: "reports/report-word",
//     type: "word",
//   },
// };nst FILE_TYPE = {
//   excel: {
//     ext: "xls",
//     url: "reports/report-excel",
//     type: "excel",
//   },
//   word: {
//     ext: "doc",
//     url: "reports/report-word",
//     type: "word",
//   },
// };
const DEFAULT_REPORT_FILTER = {
  fromDate: new Date(),
  toDate: new Date(),
  // date: new Date(),
  warehouseId: null,
  // downloadFileType: FILE_TYPE.excel.type,
};
export default {
  name: "ReportBasicToolDialog",
  components: { VueSelect },
  data() {
    return {
      // selectedWarehouses: [],
      warehouseList: [],
      dialog: false,
      reportFilter: {
        ...DEFAULT_REPORT_FILTER,
        warehouseId: null,
      },
      loading: false,
    };
  },
  methods: {
    async getWarehouses({ text, page }) {
      try {
        const params = {
          page,
          name: text,
          limit: 15,
        };
        const {
          data: { data, total },
        } = await this.$http.get("warehouse/own-list", {
          params,
        });
        return {
          data,
          lastPage: params.limit
            ? makerPagination({ limit: params.limit, total }).lastPage
            : null,
        };
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    setWarehouse(warehouses) {
      this.warehouseList = warehouses;
    },
    close() {
      this.dialog = false;
      const { formObs } = this.$refs;
      this.reportFilter = { ...DEFAULT_REPORT_FILTER, warehouses: [] };
      if (formObs) formObs.reset();
    },
    open() {
      this.dialog = true;
    },
    async materialReport() {
      try {
        this.loading = true;
        let params, url;

        if (this.$store.getters.isUserAdmin) {
          params = this.getDepartmentMaterialReportParams();
          url = "reports/department-material-report";
        } else if (this.$store.getters.roles.includes(USER_ROLES.OMTK)) {
          params = this.getAllMaterialReportParams();
          url = "reports/omtk-material-report";
        } else {
          params = this.getDepartmentMaterialReportParams();
          url = "reports/department-material-report";
        }
        const { fromDate, toDate, warehouseId } = params;
        // window.moment(fromDate).format("YYYY-MM-DD");
        // let selectedFileType =
        //   FILE_TYPE[this.reportFilter.downloadFileType] ||
        //   FILE_TYPE[this.reportFilter.downloadFileType];
        const { data } = await this.$http.get(
          `${url}?fromDate=${fromDate}&toDate=${toDate}&warehouseId=${warehouseId}`
        );
        this.downloadReport(data, "xls");
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    getAllMaterialReportParams() {
      // let params = {
      //   link: "M8ZlDj",
      //   name: "Асосий воситалар ҳисоботи",
      //   columns: {
      //     warehouse_name: {
      //       name: "warehouse_name",
      //       title: "Омбор (бўлим/цех):",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     product_type_name: {
      //       name: "product_type_name",
      //       title: "Махсулот тури",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     product_name: {
      //       name: "product_name",
      //       title: "Махсулот номи",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     accounting_code: {
      //       name: "accounting_code",
      //       title: "Ина. №",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     unit_type_name: {
      //       name: "unit_type_name",
      //       title: "ўл. Бирлик",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     price: {
      //       name: "price",
      //       title: "Бошланғич қиймат",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     b_qty: {
      //       name: "b_qty",
      //       title: "Бошланғич қолдиқ сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     b_amt: {
      //       name: "b_amt",
      //       title: "Бошланғич қолдиқ қиймати",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     k_qty: {
      //       name: "k_qty",
      //       title: "Кирим сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     k_amt: {
      //       name: "k_amt",
      //       title: "Кирим қиймати",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     ch_qty: {
      //       name: "ch_qty",
      //       title: "Чиқим сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     ch_amt: {
      //       name: "ch_amt",
      //       title: "Чиқим қиймати",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     q_qty: {
      //       name: "q_qty",
      //       title: "Якуний қолдиқ сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     q_amt: {
      //       name: "q_amt",
      //       title: "Биллинг тури",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     "davr.date": {
      //       name: "davr.date",
      //       title: "Date",
      //       type: "date",
      //       columnFormat: "date",
      //       table: "Материал ҳисобот",
      //     },
      //   },
      //   selectedColumns: [
      //     "warehouse_name",
      //     "product_type_name",
      //     "product_name",
      //     "accounting_code",
      //     "unit_type_name",
      //     "price",
      //     "b_qty",
      //     "b_amt",
      //     "k_qty",
      //     "k_amt",
      //     "ch_qty",
      //     "ch_amt",
      //     "q_qty",
      //     "q_amt",
      //   ],
      //   conditions: [
      //     {
      //       columnName: "product_type_name",
      //       type: "Equals",
      //       value: "0820 (Приобретение основных средств)",
      //       order: 0,
      //     },
      //     {
      //       columnName: "davr.date",
      //       type: "Equals",
      //       value: "10.11.2021",
      //       id: 3,
      //       order: 0,
      //     },
      //   ],
      //   criteriaPattern: "",
      //   templateId: 2,
      //   filter: {
      //     start: 0,
      //     size: 10,
      //     searchKey: "",
      //     sortType: true,
      //   },
      //   templateName: this.$t("basicToolReports"),
      //   groupColumns: ["product_type_name"],
      //   htmlTemplateId: 1,
      //   isExport: true,
      // };
      let params = {
        fromDate: "",
        toDate: "",
        warehouseId: null,
      };
      const { fromDate, toDate, warehouseId } = this.reportFilter;
      /**
       * Set date conditions from filter date
       */
      params.fromDate = window.moment(fromDate).format("YYYY-MM-DD");
      params.toDate = window.moment(toDate).format("YYYY-MM-DD");
      params.warehouseId = +warehouseId;
      // params.criteriaPattern = `(1 and 2 and (${warehouses
      //   .map((_, index) => {
      //     return index + 3;
      //   })
      //   .join(" or ")}))`;
      return params;
    },
    getDepartmentMaterialReportParams() {
      const { fromDate, toDate, warehouseId } = this.reportFilter;
      // let params = {
      //   link: "YKOxCK",
      //   name: "Асосий воситалар ҳисоботи",
      //   columns: {
      //     warehouse_name: {
      //       name: "warehouse_name",
      //       title: "Омбор (бўлим/цех):",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     product_type_name: {
      //       name: "product_type_name",
      //       title: "Махсулот тури",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     product_name: {
      //       name: "product_name",
      //       title: "Махсулот номи",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     accounting_code: {
      //       name: "accounting_code",
      //       title: "Ина. №",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     unit_type_name: {
      //       name: "unit_type_name",
      //       title: "ўл. Бирлик",
      //       type: "string",
      //       columnFormat: "string",
      //       table: "Материал ҳисобот",
      //     },
      //     price: {
      //       name: "price",
      //       title: "Бошланғич қиймат",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     b_qty: {
      //       name: "b_qty",
      //       title: "Бошланғич қолдиқ сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     b_amt: {
      //       name: "b_amt",
      //       title: "Бошланғич қолдиқ қиймати",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     k_qty: {
      //       name: "k_qty",
      //       title: "Кирим сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     k_amt: {
      //       name: "k_amt",
      //       title: "Кирим қиймати",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     ch_qty: {
      //       name: "ch_qty",
      //       title: "Чиқим сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     ch_amt: {
      //       name: "ch_amt",
      //       title: "Чиқим қиймати",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     q_qty: {
      //       name: "q_qty",
      //       title: "Якуний қолдиқ сони",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     q_amt: {
      //       name: "q_amt",
      //       title: "Биллинг тури",
      //       type: "number",
      //       columnFormat: "number",
      //       table: "Материал ҳисобот",
      //     },
      //     "davr.date": {
      //       name: "davr.date",
      //       title: "Date",
      //       type: "date",
      //       columnFormat: "date",
      //       table: "Материал ҳисобот",
      //     },
      //   },
      //   selectedColumns: [
      //     "warehouse_name",
      //     "product_type_name",
      //     "product_name",
      //     "accounting_code",
      //     "unit_type_name",
      //     "price",
      //     "b_qty",
      //     "b_amt",
      //     "k_qty",
      //     "k_amt",
      //     "ch_qty",
      //     "ch_amt",
      //     "q_qty",
      //     "q_amt",
      //   ],
      //   conditions: [
      //     {
      //       columnName: "davr.date",
      //       type: "Equals",
      //       value: window.moment(date).format("DD.MM.YYYY"),
      //       order: 0,
      //     },
      //     {
      //       columnName: "product_type_name",
      //       type: "Equals",
      //       value: "0820 (Приобретение основных средств)",
      //       order: 1,
      //     },
      //   ],
      //   criteriaPattern: "",
      //   templateId: 3,
      //   filter: {
      //     start: 0,
      //     size: 20,
      //     searchKey: "",
      //     sortType: true,
      //   },
      //   description: "",
      //   folder: {
      //     valueMap: {
      //       CODE: "e1d1d6da-5dee-4110-9144-903c1c9eb403",
      //       name: "DEPARTMENT",
      //       description: "DEPARTMENT",
      //       id: "2",
      //       value: "2",
      //     },
      //   },
      //   deleted: false,
      //   templateName: this.$t("basicToolReports"),
      //   groupColumns: ["product_type_name"],
      //   htmlTemplateId: 2,
      //   isExport: false,
      // };

      let params = {
        fromDate: "",
        toDate: "",
        warehouseId: null,
      };
      params.fromDate = window.moment(fromDate).format("YYYY-MM-DD");
      params.toDate = window.moment(toDate).format("YYYY-MM-DD");
      params.warehouseId = +warehouseId;
      // params.conditions[1].value = "0820 (Приобретение основных средств)";
      // warehouses.forEach((warehouseName, index) => {
      //   params.conditions.push({
      //     order: index + 1,
      //     columnName: "warehouse_name",
      //     type: "Equals",
      //     value: warehouseName,
      //   });
      // });
      // params.criteriaPattern = `(1 and 2 and (${warehouses
      //   .map((_, index) => {
      //     return index + 3;
      //   })
      //   .join(" or ")}))`;
      return params;
    },
    downloadReport(data, selectedFileType) {
      let blob = new Blob([data], { type: selectedFileType });
      downloadBlobFile(blob, `material-report.${selectedFileType}`);
    },
  },
};
</script>

<style scoped></style>
